import { Axios } from "./request";

const API_URL = "usersapi/v1/financial-capabilities/";

export const FINANCIAL_INFORMATION_API = {
  GetFinancialInformation: () => {
    return Axios.get(`${API_URL}GetFinancialCapabilityInformation`);
  },
  AddFinancialInformation: (body) => {
    return Axios.post(`${API_URL}AddFinancialCapabilityInformation`, body);
  },
  EditFinancialInformation: (body) => {
    return Axios.put(`${API_URL}EditFinancialCapabilityInformation`, body);
  },
  GetFinancialCapabilityInformationDetails: (profileNumber) => {
    return Axios.get(
      `${API_URL}GetFinancialCapabilityInformationDetails?profileNumber=${profileNumber}`
    );
  },
  GetFinancialCapabilityInformationDetailsAfterApprovalInspector: (profileNumber) => {
    return Axios.get(
      `${API_URL}GetFinancialCapabilityInformationDetailsAfterApprovalInspector?profileNumber=${profileNumber}`
    );
  },
};
